/* eslint-disable camelcase */

const font_cera = `"Cera Pro", sans-serif`;
const font_cera_bold = `"Cera Pro Bold", sans-serif`;

export { font_cera, font_cera_bold };
